<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Agents'"
    [canGoBack]="true"
    [customBack]="'agent/triggers'"
    [linkIcon]="'pulse-outline'"
    [showLinkIcon]="true"
    (linkAction)="goToActivity()" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<tidy-unified-agent
  [mobileView]="'detail'"
  [triggerKey]="triggerKey" />
